import React, { useMemo } from 'react';
import Header from '../components/Header';
import Navigator from '../components/Navigator';
import PhotoGallery from '../components/PhotoGallery';
import '../styles/Photography.css';

const photoContext = require.context('../assets/city', false, /\.(jpe?g|png)$/i);

const CityPage = () => {
    const sortedPhotos = useMemo(() => {
        const photos = photoContext.keys().map((key) => ({
            src: photoContext(key),
            filename: key.replace(/^\.\//, ''),
        }));

        return photos.sort((a, b) => {
            const numA = parseInt(a.filename.match(/\d+/)[0], 10);
            const numB = parseInt(b.filename.match(/\d+/)[0], 10);
            return numA - numB;
        });
    }, []);

    return (
        <div className="photography-lab">
            <Header fontColor="black" floating />
            <div className="photography-header">
                <h1>City</h1>
            </div>
            <PhotoGallery photos={sortedPhotos} category="city" />
            <Navigator links={['People', 'Landscape']} />
        </div>
    );
};

export default CityPage;
